
$(document).ready(function(){
  
$('.categories-inner').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  });

$(document).ready(function() {
  var animate_slider_img = new Swiper(".animate_slider_img ", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    keyboardControl: false,
    mousewheelControl: false,
    allowTouchMove: false,
    loopAdditionalSlides: 30,
    direction: 'horizontal',
    speed: 4000,
    autoplay: {
      delay: 0.5,
      disableOnInteraction: false,
    }
  });
  var animate_slider_text  = new Swiper(".animate_slider_text", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    keyboardControl: false,
    mousewheelControl: false,
    allowTouchMove: false,
    centeredSlides: true,
    loopAdditionalSlides: 30,
    direction: 'horizontal',
    speed: 4000,
    autoplay: {
      delay: 0.5,
      disableOnInteraction: false,
    }
  });
});
